import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import _ from 'lodash';
let CompanyOrganizationService = class CompanyOrganizationService {
    constructor(CompanyApi) {
        this.CompanyApi = CompanyApi;
        /** 给产品页面去控制是否禁用批量分配按钮 */
        this.isBulkAssignDiabled = false;
    }
    updateBulkAssignDiabled(isBulkAssignDiabled) {
        this.isBulkAssignDiabled = isBulkAssignDiabled;
    }
    /* 获取公司信息 includeDomains这个字段分情况  可能传可能不传  如果不传不获取域名这个字段 */
    updateCompanyInfoList(id) {
        return this.CompanyApi.getCompanyInfo(id);
    }
    /* 新增加权限、编辑权限时会用到这里的数据 */
    makeExtendsForm(companyInfo) {
        const { ip_range, ipv6, domains, } = companyInfo;
        return {
            ip_range,
            ipv6,
            domains: _.join(domains, ','),
        };
    }
};
CompanyOrganizationService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyApi)),
    __metadata("design:paramtypes", [Object])
], CompanyOrganizationService);
export { CompanyOrganizationService };
